import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HeaderModule } from 'src/app/header/header.module';
import { verifyMFARoute } from 'src/app/route-names';
import { ApiAboutService } from 'src/app/Services/api-about.service';
import { DialogType } from 'src/app/Services/dialog.service';
import { ElectorDataService } from 'src/app/Services/elector-data.service';
import { GenericDialogComponent } from 'src/app/shared/generic-dialog/generic-dialog.component';

@Component({
    selector: 'app-scan-mfa-qr',
    imports: [CommonModule, HeaderModule, MatButtonModule],
    templateUrl: './scan-mfa-qr.component.html',
    styleUrl: './scan-mfa-qr.component.scss'
})
export class ScanMfaQrComponent {
  electionOpen: boolean = true;
  errorTitle: string = "";
  errorText: string = "";
  isNotMobileScreen = this.breakpointObserver.isMatched('(min-width: 600px)');
  isNotBigScreen = this.breakpointObserver.isMatched('(max-width: 1024px)');
  token: string | undefined;
  showCode = false;

  constructor(
    private breakpointObserver: BreakpointObserver,
    readonly electorDataService: ElectorDataService,
    private readonly router: Router,
    readonly aboutService: ApiAboutService,
    private readonly dialog: MatDialog
  ) { 
    if (this.aboutService.electionClosed) {
      this.errorTitle = $localize`Election Closed`;
      this.errorText = $localize`The election was open from ${this.aboutService.startTime} to ${this.aboutService.endTime}.`;
      this.openDialog({ type: DialogType.ERROR, title: this.errorTitle, content: this.errorText });
      this.electionOpen = false;
    }
    this.token = this.electorDataService.userAuthData()!.mfaToken;
  }

  copySecret() {
    if (navigator.clipboard && navigator.clipboard.writeText && this.token) {
      navigator.clipboard.writeText(this.token).then(() => {
        alert($localize`Secret key copied to clipboard.`);
      }).catch(() => {
        this.fallbackCopy();
      });
    } else {
      this.fallbackCopy();
    }
  }

  private fallbackCopy() {
    // Fallback for older browsers
    if(this.token) {
      const textArea = document.createElement('textarea');
      textArea.value = this.token;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      alert($localize`Secret key copied to clipboard.`);
    }
  }
  
  isIOS(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
  }

  toCodeEntry() {
    this.router.navigate(verifyMFARoute);
  }

  openDialog(data: any): void {
    const dialogRef = this.dialog.open(GenericDialogComponent, {
      data: data
    });
  }
}
